import { useRestForm } from '@shared/hooks/rest/form'
import { useEasyProvider } from '@shared/components/EasyProvider'

import * as yup from 'yup'
import axios from '@shared/utils/axios'

const schema = yup.object({
    name: yup.string().required('اكتب هذه الخانة').max(100, 'المكتوب طويل، الحد ١٠٠ حرف'),
})

export const useForm = () => {
    const {
        instance,
        setFormVisibility
    } = useEasyProvider()
    const {
        form,
        mutate,
        isPending
    } = useRestForm({
        schema,
        defaultValues: instance,
        invalidate: [['offices']],

        process: instance
            ? async office => await axios.patch(`settings/offices/${office.id}/`, office)
            : async office => await axios.post(`settings/offices/`, office),
        onFinish: sup => {
            sup()
            setFormVisibility(false)
        }
    })

    const handleClose = () => setFormVisibility(false)

    return {
        form,
        mutate,
        isPending,
        instance,
        handleClose
    }
}